// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--eMWRA";
export var container = "footer-module--container--3anUK";
export var nav = "footer-module--nav--3MedS";